// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl:'https://us-central1-firestoretest-f3d0f.cloudfunctions.net/',
  course:'course/courselist',
  trainercourse:'course/trainercourseassignlist',
  firebaseConfig : {
    apiKey: "AIzaSyBk5pl7BwScZlFe6RD9ytbBZole0ZqVbfs",
    authDomain: "firestoretest-f3d0f.firebaseapp.com",
    databaseURL: "https://firestoretest-f3d0f.firebaseio.com",
    projectId: "firestoretest-f3d0f",
    storageBucket: "firestoretest-f3d0f.appspot.com",
    messagingSenderId: "296180374837",
    appId: "1:296180374837:web:2592000b9c5eaa5a17407c"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
